module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.35.05.7d6de36c.jpg";